import { BrowserRouter, Route, Routes } from "react-router-dom";
import AddUser from "../../pages/AddUser";
import Dashboard from "../../pages/Dashboard";
import EditUser from "../../pages/EditUser";
import Login from "../../pages/Login";
import UserList from "../../pages/UserList";
import { AuthProvider } from "../../services/AuthContext";
import PrivateRoute from "./PrivateRoute";
import LocationList from "../../pages/LocationList";
// import UserLiveLocation from "../../pages/UserLiveLocation";
import AddLocation from "../../pages/AddLocation";
import EditLocation from "../../pages/EditLocation";
import PartyList from "../../pages/PartyList";
// import PartyDetails from "../../pages/PartyDetails";
import PartyHistory from "../../pages/PartyHistory";
import LeavesStatus from "../../pages/LeavesStatus";
import UserProfile from "../../pages/UserProfile";
import DashboardNew from "../../pages/DashboardNew";
// import LeaveApprovalPage from "../../pages/LeaveApproval";

export default function NavRouting() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/dashboard-new" element={<PrivateRoute><DashboardNew /></PrivateRoute>} />
          <Route path="/user-list" element={<PrivateRoute><UserList /></PrivateRoute>} />
          <Route path="/edit-user/:id" element={<PrivateRoute><EditUser /></PrivateRoute>} />
          <Route path="/add-user" element={<PrivateRoute><AddUser /></PrivateRoute>} />
          {/* <Route path="/party-details" element={<PrivateRoute><PartyDetails/></PrivateRoute>} /> */}
          <Route path="/location-list" element={<PrivateRoute><LocationList /></PrivateRoute>} />
          <Route path="/add-location" element={<PrivateRoute><AddLocation /></PrivateRoute>} />
          <Route path="/edit-location" element={<PrivateRoute><EditLocation /></PrivateRoute>} />
          <Route path="/party-list" element={<PrivateRoute><PartyList /></PrivateRoute>} />
          {/* <Route path="/party-history" element={<PrivateRoute><PartyHistory /></PrivateRoute>} /> */}
          {/* <Route path="/user-live-location" element={<PrivateRoute><UserLiveLocation/></PrivateRoute>} /> */}
          <Route path="/leaves" element={<PrivateRoute><LeavesStatus /></PrivateRoute>} />
          <Route path="/user-profile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
          {/* <Route path="/leaves/:id" element={<PrivateRoute><LeaveApprovalPage /></PrivateRoute>} /> */}


          {/* <Route path="*" element={<NoPage />}/> */}
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
